import React from "react";

export const Rules = (props) => {
    return (
        <div id="rules" className="text-center">
            <div className="container">
                <div className="section-title">
                    <h2>遊戲規章</h2>
                    <p>
                        歡迎來到【佰鑽 Online】遊戲平台（以下簡稱本遊戲），為保障您的權益，請於註冊成為【佰鑽 Online】會員並開始使用本遊戲之服務前，詳細閱讀本服務條款之所有內容。
                    </p>
                </div>
                <div className="row">
                    <h6>一、使用者登錄資料真實性：</h6>
                    <ol>
                        <li>使用者在本公司網站註冊之個人基本資料（以下簡稱註冊資料）與實際狀況不符時，本公司將不對其帳號提供服務（例如：帳號、密碼查詢，申請遊戲歷程，活動領獎等）。
                        </li>
                        <li>若使用者於註冊帳號時，使用不實之註冊資料或將其「遊戲帳號」、「密碼」或「遊戲相關資料」洩漏，或以有償、無償方式轉讓予他人時，本公司有權暫停該帳號使用本服務並由使用者自行承擔所有之損失與損害，並保留所有法律追訴之權利。
                        </li>
                    </ol>
                    <h6>二、違規處罰事項：</h6>
                    <ol>
                        <li>不當發言<br />例如：不實言論、不當煽動言論、涉及人身攻擊</li>
                        <li>不當遊戲行為<br />例如：外掛、竄改遊戲程式</li>
                        <li>利用【佰鑽 Online】遊戲平台買賣遊戲幣</li>
                        <li>利用【佰鑽 Online】遊戲平台買賣道具，非於遊戲中正常使用</li>
                        <li>利用【佰鑽 Online】遊戲平台散佈、宣傳具商業廣告、或刊登援交色情之資料、網站，或從事仲介行為。</li>
                        <li>利用【佰鑽 Online】遊戲平台買賣、收受、轉讓遊戲帳號。</li>
                        <li>冒充官方人員利用【佰鑽
                            Online】遊戲平台，冒用本公司遊戲客服人員或遊戲管理員之身分或申請容易被誤認為客服人員或遊戲管理員之暱稱，與使用者進行任何互動。
                        </li>
                        <li>使用外掛程式、破解遊戲系統或惡意利用遊戲之程式錯誤（BUG）或遊戲規則漏洞，取得或修改遊戲幣或道具。</li>
                        <li>重覆申請帳號破壞遊戲秩序或利用遊戲機制取得不當利益者。</li>
                        <li>惡意申訴回報、辱罵，影響客服人員及客服中心作業(包含【佰鑽
                            Online】遊戲所有服務平台、遊戲公開頻道或密頻頻道)。</li>
                        <li>活躍度異常之使用者屢遭使用者檢舉。</li>
                        <li>利用【佰鑽 Online】遊戲平台，涉及盜用、詐欺等違反法令之行為。</li>
                        <li>經司法機關查獲或查證使用者疑似從事不法之行為。</li>
                        <li>利用【佰鑽
                            Online】遊戲平台散佈、宣傳法令所不允許之言論或引誘人犯罪之言論。（例如：硬的、軟的、男生、女生、買賣糖果…等所有販毒的代名詞）
                        </li>
                        <li>明知或因重大過失不知遊戲幣或道具係違法或不當取得者，仍為收受之行為。</li>
                    </ol>
                    <p>【本公司得視使用者違反上列各點事項之情狀、次數及嚴重程度等因素，於基本處罰方式以外採取任何本公司認為適當之處置，違規之使用者不得異議。】<br />【使用者同意依服務條款第7.5條後段約定，於本公司處以使用者禁登或終止契約等處置後，使用者均不得以已儲值且使用(
                        例如：兌換成遊戲幣或虛擬商品等)之點數，向本公司或原儲值平台要求退費或請求損害賠償。】</p>
                    <h6>三、違規事項說明：</h6>
                    <ol>
                        <li>違規事項屬於不當行為<ol>
                            <li>若查明屬實確有以不當方式來進行遊戲、使用本遊戲服務或藉由本遊戲服務從事不當行為者，造成其他使用者線上虛擬財產（遊戲幣或其他虛擬物品）損失或競賽不公，本公司得於通知使用者之後，按其情節輕重限制其遊戲使用權利，以維護其他使用者權益與【佰鑽
                                Online】遊戲環境。贈禮功能為附加功能，並非遊戲必要功能，玩家之贈禮行為若有影響遊戲公平性之疑慮，本公司有權基於維護遊戲秩序而調整玩家的贈禮功能權限。使用者禁止於遊戲中販售、購買遊戲幣或其他虛擬物品。除此之外，所有參與或協助違反本遊戲管理規章行為之使用者帳號，本公司亦將以相同條例處理之。
                            </li>
                            <li>不當行為應包含但不限於以下行為：<ol>
                                <li>惡意透過遊戲系統的程式錯誤(BUG)，或以任何形式之非遊戲所附程式或任何更改原始程式及系統上的鎖定與解除鎖定系統設定等不正當方式（如：侵入、攔截、破壞、修改遊戲資料、封包值），來取得遊戲中不當遊戲戰績、影響遊戲公平性者。
                                </li>
                                <li>以他人帳號進行交易、利用遊戲獲取不當利益或其他違反公平合理之方式使用本服務者。
                                </li>
                                <li>利用【佰鑽
                                    Online】遊戲平台上或各款遊戲中的機制，刻意造成遊戲幣等遊戲資產不當流向。
                                </li>
                                <li>於遊戲中買賣遊戲幣、遊戲點數或其他相關虛擬物品。</li>
                                <li>疑似利用線上儲值的方式盜買點數者。</li>
                                <li>利用【佰鑽
                                    Online】遊戲平台散佈、宣傳具商業廣告或刊登援交色情之資料、網站，或從事仲介行為。
                                </li>
                                <li>從事傷及第三人權益與隱私之行為（例如：違反個人資料保護法）。</li>
                                <li>干擾遊戲或活動進行，且經線上管理人員勸告仍不聽從改善。</li>
                                <li>冒用本公司遊戲客服人員或遊戲管理員之身分或申請容易被誤認為客服人員或遊戲管理員之暱稱，與使用者進行任何互動。
                                </li>
                                <li>利用【佰鑽
                                    Online】遊戲平台中的聊天系統，以辱罵、誹謗、人身攻擊、威脅，或以含淫穢之意、種族歧視之言語（含諧音）攻擊遊戲客服人員或其他使用者。
                                </li>
                                <li>於遊戲大廳中惡意洗頻</li>
                            </ol>
                            </li>
                            <li>發言不當為保持遊戲的善良風氣及所有使用者都可正常觀看與使用遊戲頻道，請使用者遵守網路禮儀，以維持乾淨單純的遊戲空間。使用者於【佰鑽
                                Online】遊戲平台的發言中，包含利用『直接、間接、影射、方言、俚語、錯字(注音文)、數字或圖形等代替一般的髒話、諧音、解剖學名辭、污辱及這類相關字詞的正、反向書寫等方式，與文字組合後具有下述定義的字眼與內容皆為不被允許情形』。【佰鑽
                                Online】遊戲平台上若有以下狀況，客服人員有權在無事先告知的情況，依各式情形直接進行處分，若於頻道上所發表之言論是不被允許，但未被列於以下限制說明，將由客服人員依道德社會觀念之公正認定進行裁決處以【取消發話服務】處置：
                                <ol>
                                    <li>使用者於【佰鑽
                                        Online】遊戲平台或遊戲公開頻道中發送含有低級、褻瀆、粗魯、辱罵、誹謗、人身攻擊、威脅、挑釁、種族與性別歧視、不雅文字、猥褻及含煽情淫穢、具有色情內容或含意、有違社會善良風俗的慣用詞彙之言詞內容，影響其他使用者進行遊戲之觀感。
                                    </li>
                                    <li>使用者於【佰鑽
                                        Online】遊戲平台中，遊戲言詞內容假冒官方人員，或是自稱官方代表、遊戲管理者等。
                                    </li>
                                    <li>蓄意妨礙、辱罵或欺騙官方人員。</li>
                                    <li>於【佰鑽
                                        Online】遊戲平台散佈對於本公司未經證實或無具體事實根據的不實言論，包含惡意以文字或圖片形式公開或未公開之訊息，或是純屬使用者個人揣測等，企圖影響其他使用者進行遊戲之觀感。若因此造成本公司損害，本公司並得請求相關損害賠償。
                                    </li>
                                    <li>於【佰鑽
                                        Online】遊戲平台公開頻道(兩人以上即屬公開頻道)洗頻或重複發言多次，造成使用者無法正常觀看頻道之情形，例如持續發言無意義的內容(如英數字、亂碼、符號、表情、指令、系統預設文字)，或使用相同循環之文字進行重覆且有頻率的方式發言，皆構成洗頻。
                                    </li>
                                    <li>使用者於公開頻道上處理私人糾紛或是互相謾罵，以及試圖散佈並影響其他使用者加入紛爭，干擾其他使用者進行遊戲。
                                    </li>
                                    <li>於【佰鑽
                                        Online】遊戲平台上，違反個人隱私資料的保護，例如：透露其他使用者之個人資料。
                                    </li>
                                    <li>於【佰鑽
                                        Online】遊戲平台上進行商業廣告之行為與內容(如兜售與遊戲無關之商品、涉及現實有價物交易之廣告行為)
                                    </li>
                                </ol>
                            </li>
                            <li>不當名稱與非法頭像(含遊戲內暱稱、大頭貼)遊戲內的角色名稱及頻道名稱為使用者創立時自行輸入，角色及頻道名稱一經設定後將無法任意變更，請使用者妥善為自己心愛的角色及頻道命名。使用者角色及頻道名稱如不當違反命名規定，將在無事先告知的情況下遭到鎖定、刪除、解散或者變更名稱的處置。若有以下狀況，客服人員有權在無事先告知的情況，依各式情形直接進行處分，但未被列於以下限制說明，將由客服人員依道德社會觀念之公正認定進行裁決：
                                <ol>
                                    <li>網站及各式名稱不得與官方工作人員名稱類似、假冒本公司相關組織名稱，以及與工作人員名稱混淆之名稱，包含中間僅以普通使用者可能無法辨識之特殊字形區隔之以上類似組合。例如：客服、開翻天、GM等皆屬本公司官方人員。
                                    </li>
                                    <li>有影射、褻瀆、粗魯、辱罵、誹謗、人身攻擊、威脅、挑釁本公司或從業人員含意之使用者暱稱。例如：白痴克服。
                                    </li>
                                    <li>遊戲角色名稱含有種族與性別歧視、不雅文字、猥褻及含煽情淫穢、具有色情內容或含意、有違社會善良風俗的慣用詞彙之言詞。例如：誰要一夜情、援交妹。
                                    </li>
                                    <li>遊戲角色名稱含違法行為或誘人犯罪文字。（例如：販毒，言詞中含販毒之名稱）。
                                    </li>
                                </ol>
                            </li>
                            <li>利用程式錯誤（BUG）進行遊戲(含宣傳、散播消息)使用者不可利用遊戲中非自然或非刻意之錯誤BUG或以違反公平合理之方式、手段進行遊戲(未公告BUG之部份將以本公司認定為主)或遊戲漏洞，甚至造成伺服器負擔加重或當機等，讓自己受惠或牟利他人，導致遊戲失衡之行為。使用者在發現遊戲的BUG後，應及時向遊戲管理人員反映。如使用者利用遊戲程式的BUG、漏洞或規則不盡完善之處或以其他任何非正常方式而取得之不當利益暴增等等，導致遊戲造成不平衡等損失，與影響其他使用者權益或造成不屬於原先設計範圍效果，所有關係者經查證屬實後之一切資料，本公司將採取遊戲帳號【暫時凍結】方式，並回收使用者利用BUG進行遊戲而直接、間接獲得之非法利益，但若發生之情形過於重大而有無法正確回收非法利益，或該非法利益可能連帶產生其他無法回溯之情況，本公司以書面或官方聯絡渠道告知後，將暫停其遊戲使用權直至使用者帳號資料修正為止，或對該遊戲帳號之所有角色進行重置為全新角色之處分，並且將回溯至正常資料之前的備檔資料。
                            </li>
                            <li>惡意篡改遊戲程式使用者不得侵入、攔截、破壞遊戲程式，或對遊戲進行修改、編譯、修改遊戲程式記憶體編碼或解除遊戲程式加密，或以任何方式篡改、複製更改封包及數值等，來變更遊戲程式內容資料，而取得之不當利益暴增等等，而導致遊戲造成不平衡等損失，與影響其他使用者權益及造成不屬於原先設計範圍效果，所有關係者經查證屬實後之一切資料，本公司經查證屬實者，將回收使用者惡意篡改遊戲程式進行遊戲而直接、間接獲得之非法利益，本公司有權在無事先告知的情況，立即對所有相關帳號終止契約，其非法所得之遊戲幣、道具等將一併回收，且本公司將保留法律追溯權。
                            </li>
                        </ol>
                        </li>
                        <li>違規事項屬於非法行為非法行為應包含但不限於以下行為：<ol>
                            <li>於【佰鑽 Online】遊戲平台上進行販賣毒品、槍械等不法物品或涉及刊登援交、色情等不法廣告。
                            </li>
                            <li>於【佰鑽 Online】遊戲平台上散佈具有犯罪行為或是教唆犯罪之內容。</li>
                            <li>於【佰鑽
                                Online】遊戲平台散佈、宣傳法律規定之不法行為或誘人犯罪（例如：販毒、言詞中含販毒之名稱）。
                            </li>
                        </ol>
                        </li>
                    </ol>
                    <h6>四、舉發『駭客』、『舞弊』：</h6>
                    <ol>
                        <li>為落實維護遊戲公平性與協助本公司取締可能用『駭客』和『舞弊』行為使用者，您同意【佰鑽
                            Online】用戶端(CLIENT)程式無須對您通知即可從您的電腦及其元件中獲得某些資訊，包括但不限於您的鍵盤、滑鼠、顯示卡、網路卡、CPU、RAM、IP位址等相關資訊，其中包含是否同時有與【佰鑽
                            Online】遊戲同時運行之『未經許可的第三方程式』。前述資訊僅用於保護使用者、維護遊戲品質及找出惡意不當或違法行為之使用者等以及追溯資料。
                        </li>
                        <li>上述所稱『未經許可的第三方程式』係指未經本公司同意使用之程式，包括但不限於本公司獨自判定(1)能進行或提供任何舞弊；(2)能讓遊戲client端程式修改或侵入遊戲介面、環境；或(3)攔截、挖掘或以其他方式或透過遊戲收集資訊的任何“addon”或“mod”的第三方軟體。
                        </li>
                    </ol>
                    <h6>五、優質愉快的遊戲環境需要大家共同監督維護，若發現任何本公司禁止之違規行為，本公司需要您的協力檢舉並立即回報，檢舉方式如下：
                    </h6>
                    <ol>
                        <li>逕行舉發為消弭遊戲中不公平現象，遊戲管理員每日針對前一日遊戲成績與相關遊戲資產之數額進行安全檢查。凡遊戲歷程有作弊嫌疑或相關遊戲資產數量不正常增加之使用者，都將列入考核名單，經查證屬實，本公司得於通知使用者後，立即終止本契約。
                        </li>
                        <li>回報／檢舉告發<br />
                            <ol>
                                <li>若有發現疑似違反本遊戲規章者，可向本公司回報或檢舉告發。本公司接獲通知後，將立即查明。如查證屬實，本公司得於通知被告發之使用者後，公告於【佰鑽
                                    Online】遊戲官網。</li>
                                <li>進行回報或檢舉，請附上<br />
                                    <ol>
                                        <li>您的暱稱（若為檢舉，請同時附上：您所要檢舉的使用者的暱稱）</li>
                                        <li>事由</li>
                                        <li>事發時間、地點（遊戲區或單元或活動名稱）</li>
                                        <li>拍下的完整圖片或其他可供佐證之資料。請注意：若為檢舉，受理期限以事發當月起算一個月內，逾時恕不受理。
                                        </li>
                                    </ol>
                                </li>
                                <li>進行回報或檢舉方式如下：<br />
                                    <ol>
                                        <li>【佰鑽 Online】客戶服務信箱（需附加圖片者適用）</li>
                                        <li>【佰鑽 Online】遊戲官網的『問題通報』功能</li>
                                    </ol>
                                </li>
                                <li>處分申訴請使用者依照申請使用時所同意之「服務條款」為依據，至遊戲官方網站 <a
                                    href="https://www.lybobet.com/">https://www.lybobet.com</a>聯絡客服。我們將於收到來信後儘速與申訴使用者聯絡。申訴單上須檢附使用者帳號基本資料，若非使用者資料庫中該帳號資料之原始登錄人，恕無法受理。
                                </li>
                            </ol>
                        </li>
                    </ol>
                    <h6>六、虛擬物品及遊戲幣相關規定</h6>
                    <ol>
                        <li>遊戲中開放使用者帳號以點數兌換虛擬物品或遊戲幣，惟使用者須同意，經完成兌換流程後，虛擬物品或遊戲幣僅供獲得遊戲樂趣使用，不再具有其他任何實質價值。
                        </li>
                        <li>遊戲中開放使用者以點數兌換虛擬物品或遊戲幣時，【佰鑽
                            Online】只提供單向兌換的媒介，無法將虛擬物品或遊戲幣再次換回成點數，若使用者私下有其他交易行為而造成個人損失，本公司將不負責賠償或其他法律責任。
                        </li>
                        <li>遊戲中所頒發的虛擬物品，只針對特殊活動與單一帳號進行發放，使用者不得要求本公司將真實身分中所有的帳號與個別虛擬物品集中或轉移到特定帳號。
                        </li>
                        <li>【佰鑽
                            Online】提供虛擬遊戲幣及物品互相贈與功能，但僅提供正常轉換機制，嚴禁遊戲幣買賣交易之行為。如使用者仍不聽取勸導，本公司不承擔使用者間私下交易的問題處理，且使用者不得以私下交易的結果要求本公司取消已完成轉換之虛擬物品或遊戲幣。
                        </li>
                        <li>使用者若於現實生活中與他人涉及本遊戲之道具、人物或其他各項電磁記錄之交易或互易行為，因此而產生的糾紛與本公司無涉。
                        </li>
                        <li>因天災、不可抗力或其他非人為因素而導致使用者遊戲資料或紀錄的毀損或滅失，本公司不負賠償責任。</li>
                        <li>使用者所購買的點數卡，一經儲值後，即表示使用者已經確認系統下各項服務之消費；存入使用者帳號的遊戲點數，將無法轉讓給第三者。
                        </li>
                        <li>使用者發現遊戲帳號遭人非法使用或有任何異常破壞使用安全的情形時，應立即通知本公司；若因可歸責於使用者而導致帳號、密碼、遊戲資料遭他人非法使用所造成之損失，本公司將不負責處理相關糾紛及賠償。
                        </li>
                        <li>因遊戲版本更新，造成部分使用者出現遊戲版本不正確或任何因使用者個人因素無法繼續進行遊戲（同時段內非所有的使用者無法登入【佰鑽
                            Online】遊戲伺服器），則本公司將盡力提供諮詢服務，協助使用者繼續使用本公司之服務，但該處理時段內因使用者個人電腦設備問題或自身、其他協力廠商或相關電信業者網路系統軟硬體設備之故障或失靈造成無法遊戲的損失，本公司將不負損害賠償責任。
                        </li>
                        <li>除了【佰鑽 Online】舉辦之活動與遊戲程式本身之問題外，使用者間任何私下交易的結果皆與本公司無關</li>
                        <li>【佰鑽
                            Online】服務內之遊戲所屬公會之成員間所產生的糾紛，以及社群軟體內的任何發言，都與本公司無關，本公司一概不介入處理，亦不負任何責任。
                        </li>
                    </ol>
                    <h6>七、競賽活動規範</h6>
                    <ol>
                        <li>舉凡本公司與有獎競賽相關的各活動，無論為常態或不定期舉辦，使用者一旦經由遊戲管理員查明屬實，確有在各項競賽活動中從事本遊戲規章中所明訂禁止之行為，或其他未列舉而影響遊戲公平性的非正當遊戲方式，本公司都將按照本規章從嚴處置，並且判定喪失繼續參賽與獲獎資格。
                        </li>
                        <li>各競賽活動若有其他未在本規章訂定範圍內之條文，將在各競賽活動之相關網頁中另行訂定，並自其公告日起生效實施。
                        </li>
                    </ol>
                    <h6>八、其他特殊活動辦法與管理</h6>
                    <p>舉凡本公司因功能需求或針對不同主題所舉辦之特殊活動，本公司會提供該項功能／活動的使用說明與規範，若使用者對於新增的服務內容或遊戲活動比賽方式有不同意之處，請勿使用該項功能或請勿參與該項活動比賽。
                    </p>
                    <h6>九、本公司之客服及遊戲管理員(GM)不予受理之情事</h6>
                    <ol>
                        <li>持續傳送空白訊息或毫無意義的訊息給遊戲管理員(GM)內容，以致於影響其他使用者諮詢，經遊戲管理員(GM)告知無效後，將暫時拒絕提供該使用者線上諮詢服務。
                        </li>
                        <li>在特定活動或競賽的相關規定期限後，逾期詢問虛擬或實體贈品、獎品之兌獎領獎事宜。</li>
                        <li>點數卡開卡儲值後，要求本公司進行回復、轉讓、更改配點設定。</li>
                        <li>本公司禁止使用者利用本遊戲服務進行任何商業行為。若使用者之間有任何私下交易，不得以結果或糾紛要求本公司取消或回復已完成之虛擬遊戲幣轉匯，惟使用者違反服務條款或遊戲規章時，本公司將按照相關內容進行處理。
                        </li>
                        <li>使用者之間若於遊戲有特殊玩法設定，除了涉及以違反公平合理之方式或手段進行遊戲之外，遊戲管理員(GM)不介入處理。
                        </li>
                        <li>使用者之間私人恩怨、糾紛，遊戲管理員(GM)不介入處理，但不得於公開頻道發送低級、褻瀆、粗魯、辱罵、誹謗、人身攻擊、威脅、挑釁、種族與性別歧視、不雅文字、猥褻及含煽情淫穢、具有色情內容或含意、有違社會善良風俗的慣用詞彙之言詞內容，影響其他使用者進行遊戲之觀感。
                        </li>
                        <li>詢問關於公司內部、系統方面、遊戲內部數值設定或是GM私人問題或其他使用者的個人資料等非相關遊戲進行的問題，為保守公司內部機密資訊，以及保持高品質的服務並保障所有使用者的權益，本公司將不受理使用者詢問，請使用者配合。
                        </li>
                        <li>如使用者之間發生虛擬物品轉移糾紛時，請使用者自行互動調解，GM不擔任仲裁的角色亦不受理類似的相關問題。</li>
                        <li>使用者在非遊戲內的通訊軟體發生任何糾紛時，請使用者自行互動調解，GM不擔任仲裁的角色亦不受理類似的相關問題。
                        </li>
                    </ol>
                    <h6>十、本公司不進行損失補償之情形</h6>
                    <ol>
                        <li>使用者若因本身網路服務業者網路斷線、或自動離線、或電腦程式錯誤，發生斷線情形，而造成遊戲資料或記錄，如戰績與點數有所損失，本公司得不予補償。
                        </li>
                        <li>因戰爭、天災、其他不可抗力因素或其他非人為因素，導使使用者於遊戲中途被迫離線，係屬無法事先防範的事實災害。因此使用者當日所損失的遊戲資料，如戰績與點數，本公司將不另做損失補償。
                        </li>
                    </ol>
                    <h6>十一、相關風險與責任，由使用者自行負擔之情形</h6>
                    <ol>
                        <li>本公司之各項使用者服務可能發生下列情形：<ol>
                            <li>網站設備進行必要之保養。</li>
                            <li>自身、其他協力廠商或相關電信業者網路系統軟硬體設備之故障或失靈。</li>
                            <li>因人為操作上之疏失而造成中斷、暫時無法使用、遲延、資料傳輸或儲存上之錯誤。</li>
                            <li>遭第三人侵入系統篡改或偽、變造資料。</li>
                            <li>因戰爭、天災、其他不可抗力因素或其他非人為因素，致使本公司設備無法正常運作。</li>
                        </ol>
                        </li>
                        <li>上述情形，本公司不擔保各項服務之正確、完整、安全、可靠、合適、時效、穩定、不會斷線及出錯。</li>
                        <li>使用者需明白使用本服務之所有風險及可能致生之任何損害，不得因此而要求任何補償或賠償，並且同意本公司對於使用者所傳送之訊息、檔案及其他資料做備份。若因使用者所為之傳送過程而造成訊息、檔案及其他資料之遺失，本公司不負任何擔保責任。
                        </li>
                        <li>使用者在本公司網站上傳之資料（如談話、指令等），其內容限制如下：<br />
                            <ol>
                                <li>禁止侵犯任何第三者的智慧財產權，或其他公眾／私人權利。</li>
                                <li>禁止違反任何法律或善良風俗。</li>
                                <li>禁止任何誹謗或侮辱他人，性騷擾，種族歧視或對孩童有不良影響的內容。</li>
                            </ol>
                        </li>
                        <li>以上均屬於使用者的個人行為，一旦發生，使用者須自行負擔相關法律責任。</li>
                    </ol>
                    <h6>十二、交易或購買使用非法儲值序號</h6>
                    <ol>
                        <li>線上購買來路不明的遊戲序號是不安全的。使用者不得與他人私下進行遊戲點數交易，若因而購買到利用線上付費機制（如信用卡、電信小額付費）盜刷而得的遊戲儲值序號，本公司將對該使用者施以暫時凍結處分，直到該使用者完成付款動作後，始予以復權。而線上付費機制盜刷的相關法律責任也將由該帳號之使用者自行負擔，本公司亦會配合司法單位進行調查。
                        </li>
                        <li>本公司禁止使用者利用【佰鑽
                            Online】服務進行任何商業行為。若使用者之間有任何私下交易，其結果或糾紛本公司一概不負責任。</li>
                        <li>使用者有義務妥善保管在【佰鑽 Online】之帳號與密碼，不洩露、出借、轉讓，或提供予第三人知悉。</li>
                        <li>若發現帳號或密碼遭人偷盜、非法使用或有任何異常破壞使用安全之情形，應立即通知本公司，以利本公司採取相關措施。但不得將本公司所採取之措施解釋為本公司有明示或默示擔保或賠償責任。對於使用者的帳號及密碼遭人非法使用，本公司不負任何賠償責任，但可申請遊戲歷程至各地警察局電腦犯罪偵查組報案，依照法律程序偵辦處理。
                        </li>
                        <li>本公司將依法提供相關資料，配合案件之協助調查</li>
                    </ol>
                    <h6>十三、網路犯罪報案協助</h6>
                    <p>目前針對網路遊戲上使用者帳號遭盜用或是遭詐騙，司法單位在實行網路犯罪報案程序時，第一時間需要帳號所有者提出帳號持有證明及相關報案必備資料。
                        此時，使用者可與本公司聯絡，申請帳號證明書及遊戲歷程；當相關文件完成，本公司將以掛號方式寄送『遊戲歷程』及『帳號證明書』。
                    </p>
                    <p>本公司依法恕不能主動為使用者提出網路犯罪相關的控訴，由於大部分的行騙行為是誘騙使用者以交易方式達成目的，以達到留下銀貨兩訖的確認交換動作，在官方以記錄判斷的立場上是難以處理這方面各說各話的糾紛，並且無法依照單面說詞而為使用者強制取回財物或告知對方資料，並無法對此類問題予以裁奪，請使用者特別注意。
                    </p>
                    <p>如使用者不幸發生詐欺事件，因上述行為產生涉及法律行為之糾紛，被害者可儘快與客服聯繫，依正確客服申請流程取得相關報案必備資料，至鄰近縣市警察局報案。當本公司收到相關機關所發送的協助調查的公文時，本公司將依法提供司法單位所需之數據資料，以供查詢佐證，盡力協助警方偵辦，將不肖使用者於現實社會中繩之以法。
                    </p>
                    <p>北部：<br />刑事局電腦犯罪調查科：（02）2370-0693<br />台北市刑警大隊：（02）2381-7263<br />台北市警察局網路犯罪組：（02）2343-3980<br />警政署刑事警察局-偵九隊：（02）2764-4490、（02）2764-4434
                    </p>
                    <p>中部：<br />台中市警察總局：（04）2327-3953、（04）2328-9100轉2032</p>
                    <p>南部：<br />高雄市警察總局：（07）212-0800<br />(以上單位資訊若有誤，以單位網站公布之資訊為主)
                    </p>
                    <h6>十四、使用者申請遊戲歷程說明與注意事項</h6>
                    <p>使用者帳號遭盜用或遊戲中被詐騙欲報警處理的使用者，需由本公司提供遊戲歷程，警方才會受理。報案流程如下：</p>
                    <ol>
                        <li>請您至官方網站聯絡客服，載明您欲申請遊戲歷程的緣由。</li>
                        <li>本公司在收到您的留言，核對身分資料及審核內容皆無誤後，即會通知付費。申請遊戲歷程所需之服務費用為新台幣200元，需自行匯款至客服中心所提供的銀行帳號內。待付費完成，與客服專員確認完畢後，即轉交相關部門為您調閱歷程。將於七個工作天（不含例假日）內，以掛號或官方聯絡渠道寄出『遊戲歷程』、『帳號證明書』給您，並在資料寄出後由客服專員以聯絡方式通知。
                        </li>
                        <li>請您持『遊戲歷程』、『帳號證明書』至鄰近轄區分局報案，完成報案程序後，本公司將在警方來函後提供詳細資料配合檢調偵查，故請在完成報案流程後，向警方偵辦單位確認辦案進度。
                        </li>
                        <li>提醒使用者注意！若提出的申訴案件中，涉及使用者帳號遭盜用，或涉及私人之間的詐欺、糾紛等電腦犯罪事件時，依據個人資料保護法，本公司在政府司法單位沒有介入調查並來函通知本公司配合後續處理前，依法不能涉入該件糾紛及協助或處置。
                        </li>
                        <li>受限於電磁資料保管義務，每份歷程僅提供最多30天內的紀錄，帳號申請調閱之紀錄僅提供查詢申請日起算的前３個月。(註：若帳號要申請近三個月的遊戲歷程記錄，則必須申請三份遊戲歷程。)請盡早申請以方便作業；超過受理期限，恕不接受辦理，敬請注意。
                        </li>
                        <li>申請遊戲歷程前，請確定您登錄於本公司使用者資料庫中的個人資料，本公司只能讓於使用者資料庫中該帳號資料中之原始登錄人查詢所屬帳號內之資料，非本人則不提供查詢。
                        </li>
                        <li>申請【遊戲歷程】僅受理查詢單組帳號之遊戲歷程紀錄，超過一組或多組遊戲帳號申請時，請分別填寫申請書提出申請。
                        </li>
                    </ol>
                    <h6>十五、條款變更權利聲明</h6>
                    <p>本公司保有增減或變更本規章條款的權利，且使用者同意就【佰鑽
                        Online】遊戲網站的使用受本規章最新版本的拘束。本規章條款如有任何更新，本公司將會公告這些變更，並且在本文件中更新修訂日期。前述公告並構成對使用者的有效通知。
                    </p>

                </div>
            </div>
        </div>
    );
};
